import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import {
  filterRowsBySalesImportBranch,
  readSalesImportBranchFilter,
  SALES_IMPORT_BRANCH_OPTIONS,
  salesImportBranchDisplayName,
  writeSalesImportBranchFilter,
} from "../config/salesImportBranchIds";

const SalesImportBranchContext = createContext(null);

export function SalesImportBranchProvider({ children }) {
  const [branchId, setBranchIdState] = useState(readSalesImportBranchFilter);

  const setBranchId = useCallback((id) => {
    const next = id || "all";
    setBranchIdState(next);
    writeSalesImportBranchFilter(next);
  }, []);

  const branchOptions = SALES_IMPORT_BRANCH_OPTIONS;

  const branchFilterLabel = useMemo(
    () => (branchId === "all" ? "All branches" : salesImportBranchDisplayName(branchId)),
    [branchId]
  );

  const filterRows = useCallback(
    (rows) => filterRowsBySalesImportBranch(rows, branchId),
    [branchId]
  );

  const value = useMemo(
    () => ({
      branchId,
      setBranchId,
      branchOptions,
      branchFilterLabel,
      filterRows,
      isAllBranches: branchId === "all",
    }),
    [branchId, setBranchId, branchOptions, branchFilterLabel, filterRows]
  );

  return (
    <SalesImportBranchContext.Provider value={value}>{children}</SalesImportBranchContext.Provider>
  );
}

export function useSalesImportBranchFilter() {
  const ctx = useContext(SalesImportBranchContext);
  if (!ctx) {
    throw new Error("useSalesImportBranchFilter must be used within SalesImportBranchProvider");
  }
  return ctx;
}
